import Vue from "vue";
import Vuex from "vuex";
import bookRemunerations from "./bookRemunerations";
import cashFlowHistory from "./cashFlowHistory";
import classification from "./classification";
import financialEntity from "./financialEntity";
import fintoc from "./fintoc";
import graphCashFlow from "./graphCashFlow";
import {
    financialReports,
    salesReport,
    salesAnalysis,
    costsAnalysis,
    clientDetail,
    expensesReport,
    costsReport,
    assetsReport,
    nonOperationalReport,
    profitabilityReport,
    kpisReport,
    reportsFilters,
} from "./financialReports";
import taxDocument from "./taxDocument";
import uploadFiles from "./uploadFiles";
import userAuth from "./userAuth";
Vue.use(Vuex);

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    getters: {},
    modules: {
        bookRemunerations,
        userAuth,
        taxDocument,
        financialEntity,
        graphCashFlow,
        cashFlowHistory,
        fintoc,
        classification,
        uploadFiles,
        financialReports,
        salesReport,
        salesAnalysis,
        costsAnalysis,
        clientDetail,
        expensesReport,
        costsReport,
        assetsReport,
        nonOperationalReport,
        profitabilityReport,
        kpisReport,
        reportsFilters,
    },
});
